import React, { useCallback, useState } from 'react'
import { Link } from 'gatsby'
import * as classes from './header.module.scss'
import classNames from 'classnames'
import logo from '../../images/btwo-logo-black.svg'

export const Header: React.FC = () => {
  const [showMenu, setShowMenuStatus] = useState(false)

  const closeMenu = useCallback(() => {
    setShowMenuStatus(false)
  }, [])

  const toggleMenu = useCallback(() => {
    setShowMenuStatus((prevState) => !prevState)
  }, [])

  return (
    <header className={classNames(['container', classes.header])}>
      <div className={classes.logo}>
        <Link to='/' className={classes.logo}>
          <img src={logo} alt='BTWO Content Factory - Logo' />
        </Link>
      </div>
      <div className={classNames(showMenu && classes.open, classes.navigation)}>
        <a className={classes.toggle} onClick={toggleMenu}>
          <div />
          <div />
        </a>
        <nav>
          <Link to='/' activeClassName={classes.active}>
            home
          </Link>
          <ul>
            <li>
              <Link
                activeClassName={classes.active}
                onClick={closeMenu}
                partiallyActive
                to={'/#services'}
              >
                servizi
              </Link>
            </li>
            <li>
              <Link activeClassName={classes.active} to='/clienti'>
                clienti
              </Link>
            </li>
            <li>
              <Link activeClassName={classes.active} to='/network'>
                network
              </Link>
            </li>
            <li>
              <Link activeClassName={classes.active} to='/training'>
                training
              </Link>
            </li>
            <li>
              <Link activeClassName={classes.active} to='/team'>
                team
              </Link>
            </li>
            <li>
              <Link activeClassName={classes.active} to='/contatti'>
                contatti
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}
